export const recursivelyCheckIfNullValues = (value) => {
  if (value === null) {
    return true;
  }
  if (Array.isArray(value)) {
    if (value.some(recursivelyCheckIfNullValues)) {
      return true;
    }
  }
  if (value !== null && typeof value === 'object') {
    if (Object.values(value).some(recursivelyCheckIfNullValues)) {
      return true;
    }
  }

  return false;
};

const verifyLocationStationContent = (locationStationState) => {
  const locationStation = { ...locationStationState };

  delete locationStation.error;
  delete locationStation.loading;
  delete locationStation.location;
  delete locationStation.id;
  delete locationStation.exerciseTime;
  delete locationStation.restTime;

  return !recursivelyCheckIfNullValues(locationStation);
};

export default verifyLocationStationContent;
